<template>
  <div>
    <div class="login-form login-signin">
      <h4 class="text-left mt-6 mb-8 font-weight-bold">Lupa Password</h4>

      <b-form class="form" autocomplete="off" @submit.stop.prevent="onSubmit">
        <div
          role="alert"
          v-if="errors.length"
          class="alert alert-danger mt-3"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <b-form-group>
          <div class="input-title">Email</div>
          <b-form-input
            autocomplete="off"
            class="form-control form-control-solid h-auto py-5 px-6"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            aria-describedby="email-feedback"
            placeholder="Email"
            style="background-color: #EEF1F5; border-radius: 8px;"
          />
          <b-form-invalid-feedback id="email-feedback">
            Mohon isi Email.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <div class="input-title">Kode OTP</div>
          <b-form-input
            autocomplete="one-time-code"
            class="form-control form-control-solid h-auto py-5 px-6"
            v-model="$v.form.otp.$model"
            :state="validateState('otp')"
            aria-describedby="otp-feedback"
            placeholder="Masukkan OTP"
            style="background-color: #EEF1F5; border-radius: 8px;"
          />
          <b-form-invalid-feedback id="otp-feedback">
            Mohon isi OTP.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <div class="input-title">Password Baru</div>
          <b-form-input
            type="password"
            autocomplete="new-password"
            class="form-control form-control-solid h-auto py-5 px-6"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="password-feedback"
            placeholder="Password Baru"
            style="background-color: #EEF1F5; border-radius: 8px;"
          />
          <b-form-invalid-feedback id="password-feedback">
            <span v-if="!$v.form.password.required">Mohon isi Password Baru.</span>
            <span v-else-if="!$v.form.password.strongPassword">
              Kata sandi harus terdiri dari kombinasi huruf besar dan kecil, angka, dan simbol minimal 6 karakter.
            </span>
          </b-form-invalid-feedback>
        </b-form-group>


        <b-form-group>
          <div class="input-title">Ulangi Password Baru</div>
          <b-form-input
            autocomplete="new-password"
            type="password"
            class="form-control form-control-solid h-auto py-5 px-6"
            v-model="$v.form.retypePassword.$model"
            :state="validateState('retypePassword')"
            aria-describedby="retype-password-feedback"
            placeholder="Ulangi Password Baru"
            style="background-color: #EEF1F5; border-radius: 8px;"
          />
          <b-form-invalid-feedback id="retype-password-feedback">
            Password tidak cocok.
          </b-form-invalid-feedback>
        </b-form-group>


        <div class="d-flex flex-wrap justify-content-between align-items-center mt-5">
          <b-button
            ref="kt_login_signin_submit"
            type="submit"
            variant="primary"
            class="px-12 py-3 mt-6 w-100 font-weight-bolder"
          >
            Kirim
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";
import { LOGOUT, RESETPASSWORD } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

function strongPassword(value) {
  if (!value) return false;
  // Regex: at least one lowercase, one uppercase, one digit, one symbol, min 6 chars
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{6,}$/.test(value);
}

export default {
  mixins: [validationMixin],
  name: "ForgotPassword",
  data() {
    return {
      form: {
        email: "",
        otp: "",
        password: "",
        retypePassword: ""
      },
      errors: []
    };
  },
  validations: {
    form: {
      email: { required },
      otp: { required },
      password: {
        required,
        strongPassword
      },
      retypePassword: {
        required,
        sameAsPassword: sameAs(function () {
          return this.form.password;
        })
      }
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        this.form.email = newQuery.email || '';
        this.form.otp = newQuery.otp || '';
      }
    }
  },
  methods: {
    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.errors = [];
      this.$v.form.$touch();
      if (this.$v.form.$anyError) return;

      const email = this.$v.form.email.$model;
      const pin = this.$v.form.otp.$model;
      const new_password = this.$v.form.password.$model;
      const confirmation_password = this.$v.form.retypePassword.$model;
      this.$store.dispatch(LOGOUT);

      const btn = this.$refs.kt_login_signin_submit;
      btn.classList.add("spinner", "spinner-light", "spinner-right");

      setTimeout(() => {
        this.$store
          .dispatch(RESETPASSWORD, { email, pin, new_password, confirmation_password })
          .then((response) => {
            btn.classList.remove("spinner", "spinner-light", "spinner-right");

            if (response && response.id) {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text:
                  response.message ||
                  "Password berhasil diubah, silahkan login menggunakan password baru.",
                confirmButtonColor: "#005289"
              });
              this.form.email = "";
              this.form.otp = "";
              this.form.password = "";
              this.form.retypePassword = "";
            } else {
              const msg =
                response?.error || "Email tidak valid atau tidak ditemukan.";
              this.errors = [msg];
              Swal.fire({
                icon: "error",
                title: "Gagal",
                text: msg,
                confirmButtonColor: "#d33"
              });
            }
          })
          .catch((error) => {
            btn.classList.remove("spinner", "spinner-light", "spinner-right");

            const msg =
              error?.response?.data?.error ||
              error?.message ||
              "Email tidak ditemukan, pin tidak valid, atau terjadi kesalahan pada server.";

            this.errors = [msg];

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: msg,
              confirmButtonColor: "#d33"
            });
          });
      }, 1000);
    }
  }
};
</script>
